module.exports = __webpack_public_path__ + "static/media/beard_shave.bcbf44a3.jpg";